import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { CreateBlock, Height } from "../Blocks";
import { ShipLinkDialog } from "view/charters/dossier/ship/ShipLinkDialog";
import { SalesCharter } from "types/index";
import { showSnackbar } from "@cofano/cck";

type ShipCreateBlockProps = {
	refetch: () => void;
	charter: SalesCharter;
	resetShipNomination?: boolean;
}

const ShipCreateBlock = ({ refetch, charter, resetShipNomination }: ShipCreateBlockProps) => {

	const [ dialogOpen, openDialog ] = useState(false);

	return (
		<React.Fragment>
			<CreateBlock
				height={Height.Medium}
				onClick={() => openDialog(true)}
				title={intl.formatMessage({ id: "ADD_SHIPS" })} />

			<ShipLinkDialog
				open={dialogOpen}
				onClose={() => openDialog(false)}
				onCompleted={() => {
					showSnackbar(intl.formatMessage({ id: "SHIP_SUCCESSFULLY_LINKED" }), { variant: "success" });
					refetch();
				}}
				resetShipNomination={resetShipNomination}
				/*@ts-expect-error*/
				charter={charter} // FIXME: replace with query types
			/>
		</React.Fragment>
	);
};

export default ShipCreateBlock;
